import { printLabelRecordLog, getSkuMaterials, getWashedlabelInfo } from "@/apis/checking";
import { washlabelImages, washTemplateJson } from "@/utils/print"
import { getDefaultLabelConfig } from "@/apis/autoPrint";
import { print2, renderAndPrint } from "@/components/PrintTemplate/index.js"
import _this from '../main.js'

export const executePrintWashlabel = async function (record) {
  function headerTranslate(stationCode, str) {
    const data = {
      materialInfoJa: {
        JapanStation: '表地: ',
        KoreaStation: 'QUA: ',
        UkStation: 'Surface: ',
        default: 'Material: '
      },
      productPropertiesNameParse: {
        JapanStation: 'サイズ: ',
        KoreaStation: 'SIZE: ',
        UkStation: 'Specification: ',
        default: 'Specification: '
      },
      shopProductSku: {
        JapanStation: 'お客様SKU: ',
        KoreaStation: 'SKU: ',
        UkStation: 'Customer SKU: ',
        default: 'Customer SKU: '
      }
    }
    return data[str][stationCode] ?? data[str].default
  }

  const washLabelData = await getWashedlabelInfo({
    // systemOrderNo: 'SYSTEM24052004000012'
    systemOrderNo: record.orderCode
  })
  // 有文件直接打开
  if (washLabelData.data?.washedLabelFileUrl) {
    window.open(washLabelData.data.washedLabelFileUrl)
    return
  }
  //获取材质
  let materialInfo
  materialInfo = await getSkuMaterials({ pkgCode: record.pkgCode })
  if (materialInfo.code != 0) {
    return
  }
  if (!materialInfo.data) {
    _this.$message.warning("材质信息缺失，请联系采购")
    return
  }

  //打印
  let printdata = [{
    ...record,
    shopProductPropertiesName: washLabelData.data.washedlabelSpecification,
    shopProductSku: washLabelData.data.shopProductSku,
    //materialInfoJa 配置的打印模板入参是materialInfoJa，还是按materialInfoJa传过去
    materialInfoJa: materialInfo.data,
    ...washLabelData.data,
  }]
  //如果存在 添加表头
  if (printdata[0].materialInfoJa) {
    printdata[0].materialInfoJa = headerTranslate(record.stationCode, 'materialInfoJa') + printdata[0].materialInfoJa
  }
  if (printdata[0].shopProductPropertiesName) {
    printdata[0].productPropertiesNameParse = headerTranslate(record.stationCode, 'productPropertiesNameParse') + printdata[0].shopProductPropertiesName
  }
  if ((record.productDesignation == 3 || record.productDesignation == 2) && record.customerProductSku) {
    printdata[0].shopProductSku = headerTranslate(record.stationCode, 'shopProductSku') + record.customerProductSku
  } else {
    printdata[0].shopProductSku = undefined
  }
  console.log(printdata)

  let templateJsonCache = washTemplateJson
  function templateInt(washTemplateJson) {
    templateJsonCache = JSON.parse(washTemplateJson)
    if (printdata[0].companyLogo) {
      let imageRatio = printdata[0].imageRatio
      let options = {
        options: {
          left: imageRatio == 2 ? 8 : 41,
          top: 222,
          height: 84,
          width: imageRatio == 2 ? 150 : 84,
          src: printdata[0].companyLogo,
        },
        printElementType: {
          title: "图片",
          type: "image",
        },
      }
      if (record.stationCode != 'JapanStation') {
        options.options.styler = function () {
          return {
            transform: 'rotate(180deg)',
          };
        }
      }
      templateJsonCache.panels[0].printElements.push(options, ...washlabelImages);
    } else {
      templateJsonCache.panels[0].printElements.push(...washlabelImages)
    }
    return templateJsonCache
  }

  _this.$loading = true
  _this.$printPkg(2, record.systemSource, [{ ...printdata[0], wantPrintNum: printdata[0].amount }], templateInt, printdata[0].stationCode, record.directSaleFlag).catch(() => {
    getDefaultLabelConfig({ nodeType: 2, systemSource: record.systemSource, stationCode: printdata[0].stationCode, directSaleFlag: record.directSaleFlag }).then(res => {
      print2(templateInt(res.data.templateJson), printdata);
    })
  }).finally(() => {
    _this.$loading = false
  })
  printLabelRecordLog({ pkgCode: record.pkgCode })
}
